import { useQuery } from "@tanstack/react-query";
import api from "../../services/api/axios";

export function mergeSectorOptions(reference = [], existing = []) {
  return [...new Set([...reference, ...existing].filter((value) => typeof value === "string" && value.trim()))]
    .sort((a, b) => a.localeCompare(b));
}

export default function useNaicsSectors(existing = []) {
  const query = useQuery({
    queryKey: ["reference", "naics", "sectors"],
    queryFn: async ({ signal }) => {
      const { data } = await api.get("/reference/naics/sectors", { signal });
      if (!Array.isArray(data)) throw new Error("Invalid sector reference response");
      return data.map((row) => row.display_label).filter(Boolean);
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  return { ...query, options: mergeSectorOptions(query.data || [], existing) };
}
